import axios, { AxiosHeaders, AxiosResponse } from "axios";
import {
  GenericResponse,
  RequestGetSuscriptorName,
  RequestGetUserActive,
  RequestOrdenCompraCancelar,
  RequestOrdenCompraEstatus,
  RequestOrdenCompraGenerar,
  RequestPayPortalPayment,
  ResponseAddPayment,
  ResponseGetBalance,
  ResponseGetSuscriptorName,
  ResponseGetUserActive,
  ResponseOrdenCompraCancelar,
  ResponseOrdenCompraEstatus,
  ResponseOrdenCompraGenerar,
  ResponsePaypalId,
  ResponseRecentPayment,
  ResponseValidateSuscriptor,
} from "../types/common";
import vars from "../vars";

export class Endpoints {
  private baseURL = vars.baseUrl;
  private axiosInstance = axios.create();
  private token: string = "";

  constructor() {
    this.axiosInstance.interceptors.request.use(async (config) => {
      const headers = new AxiosHeaders();
      headers.setContentType("application/json");
      headers.set("X-HEADER", this.token);

      config.baseURL = this.baseURL;
      config.headers = headers;

      return config;
    });
  }

  public setToken(token: string): void {
    this.token = token;
  }

  public async paypalID(
    body: any
  ): Promise<AxiosResponse<GenericResponse<ResponsePaypalId>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponsePaypalId>>>(
      (resolve, reject) => {
        const path = "/paypal/id";
        this.axiosInstance
          .post(path, body)
          .then(
            (response: AxiosResponse<GenericResponse<ResponsePaypalId>>) => {
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }

  public async paypalGenerateOrder(
    body: RequestOrdenCompraGenerar
  ): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>> {
    return new Promise<
      AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>
    >((resolve, reject) => {
      const path = "/paypal/generate-order";
      this.axiosInstance
        .post(path, body)
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async paypalOrderStatus(
    body: RequestOrdenCompraEstatus
  ): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>> {
    return new Promise<
      AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>
    >((resolve, reject) => {
      const path = "/paypal/order-status";
      this.axiosInstance
        .post(path, body)
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async paypalOrderCancel(
    body: RequestOrdenCompraCancelar
  ): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraCancelar>>> {
    return new Promise<
      AxiosResponse<GenericResponse<ResponseOrdenCompraCancelar>>
    >((resolve, reject) => {
      const path = "/paypal/order-cancel";
      this.axiosInstance
        .post(path, body)
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponseOrdenCompraCancelar>
            >
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async getUserActive(
    body: RequestGetUserActive
  ): Promise<AxiosResponse<GenericResponse<ResponseGetUserActive>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponseGetUserActive>>>(
      (resolve, reject) => {
        const path = "/suscriptor/get-user-active";
        this.axiosInstance
          .post(path, body)
          .then(
            (
              response: AxiosResponse<GenericResponse<ResponseGetUserActive>>
            ) => {
              if (
                response.data.data[0] &&
                response.data.data[0].estatus === "true"
              ) {
                endpointInstance.setToken(response.data.data[0].token);
              }
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }

  public async getSuscriptorName(
    body: RequestGetSuscriptorName
  ): Promise<AxiosResponse<GenericResponse<ResponseGetSuscriptorName>>> {
    return new Promise<
      AxiosResponse<GenericResponse<ResponseGetSuscriptorName>>
    >((resolve, reject) => {
      const path = "/suscriptor/get-suscriptor-name";
      this.axiosInstance
        .post(path, body)
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseGetSuscriptorName>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async getBalance(
    idCliente: string
  ): Promise<AxiosResponse<GenericResponse<ResponseGetBalance>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponseGetBalance>>>(
      (resolve, reject) => {
        const path = "/payment/get-balance";
        this.axiosInstance
          .get(path, { params: { idCliente: idCliente } })
          .then(
            (response: AxiosResponse<GenericResponse<ResponseGetBalance>>) => {
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }

  public async getRecentPayment(
    idCliente: string
  ): Promise<AxiosResponse<GenericResponse<ResponseRecentPayment>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponseRecentPayment>>>(
      (resolve, reject) => {
        const path = "/payment/get-recent-payment";
        this.axiosInstance
          .get(path, { params: { idCliente: idCliente } })
          .then(
            (response: AxiosResponse<GenericResponse<ResponseRecentPayment>>) => {
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }

  public async addPayment(
    body: RequestPayPortalPayment
  ): Promise<AxiosResponse<GenericResponse<ResponseAddPayment>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponseAddPayment>>>(
      (resolve, reject) => {
        const path = "/payment/add-payment-portal";
        this.axiosInstance
          .post(path, body)
          .then(
            (response: AxiosResponse<GenericResponse<ResponseAddPayment>>) => {
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }

  public async validateSuscriptor(
    id: string
  ): Promise<AxiosResponse<GenericResponse<ResponseValidateSuscriptor>>> {
    return new Promise<AxiosResponse<GenericResponse<ResponseValidateSuscriptor>>>(
      (resolve, reject) => {
        const path = "/suscriptor/get-validate-customer";
        this.axiosInstance
          .get(path, { params: { id: id } })
          .then(
            (response: AxiosResponse<GenericResponse<ResponseValidateSuscriptor>>) => {
              resolve(response);
            }
          )
          .catch((error: any) => {
            reject(error);
          });
      }
    );
  }
}

export const endpointInstance = new Endpoints();
